import Styled from 'styled-components'

export default Styled.div`
  position: relative;
  background-color: ${props => props.theme.colors.white};
  height: 4.5rem;
  box-shadow: 0 0.25rem 1rem 0 rgba(51, 51, 51, 0.05);
  z-index: 10;
`



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js